import React from "react";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import SparkasseIcon from "assets/images/svg/sparkasse-icon.svg";
import UpperBlock from "./UpperBlock";
import { ACCOUNT_HASH_VARIABLES } from "constants/index";

const messages = {
    linkYourSparkasseAccount: "link_your_sparkasse_account",
    linkYourSachwertAccountSparkasse: "link_your_sachwert_account_sparkasse",
    benefitsOfLinkingAccount: "benefits_of_linking_account",
    viewInvestmentsOnePlace: "view_investments_one_place",
    trackPerformanceUnifiedDashboard: "track_performance_unified_dashboard",
    easyAccessInvestmentDetails: "easy_access_investment_details",
    linkSparkasseAccount: "link_sparkasse_account",
    completeKycWithoutLinking: "complete_kyc_without_account_linking",
};

const Benefits = ({ backSlideEffect, setBackSlideEffect, open, setStep, showTwoButtons = false }) => {
    useSideModalScrollToTop();
    const { formatMessage } = useFormattedMessage();

    const benefitsList = [
        messages.viewInvestmentsOnePlace,
        messages.trackPerformanceUnifiedDashboard,
        messages.easyAccessInvestmentDetails,
    ];

    const handleLinkClick = () => {
        setBackSlideEffect("step-slide-left");
        setStep("branch");
    };

    const handleCompleteKycWithoutLinking = () => {
        sessionStorage.setItem("fromSparkasseIdentification", "true");
        window.location.hash = `#${ACCOUNT_HASH_VARIABLES.ACCOUNT_KYC}`;
    };

    return (
        <div className={`link-sparkasse-benefits-screen ${backSlideEffect}`}>
            <UpperBlock
                icon={<SparkasseIcon />}
                title={formatMessage(messages.linkYourSparkasseAccount)}
                content={formatMessage(messages.linkYourSachwertAccountSparkasse)}
            />

            <div className="p-6 benefits-container">
                <h5 className="mt-0 mb-6">{formatMessage(messages.benefitsOfLinkingAccount)}</h5>
                <div className="benefit-list">
                    {benefitsList.map((msgKey, index) => (
                        <div key={msgKey} className="benefit-item d-flex mb-8">
                            <span className="benefit-number">{index + 1}</span>
                            <span className="text-16 benefit">{formatMessage(msgKey)}</span>
                        </div>
                    ))}
                </div>
            </div>

            {open && (
                <div className="bottom-bar-container px-6 flex-column">
                    <button className="mw-100 mb-3" onClick={handleLinkClick}>
                        {formatMessage(messages.linkSparkasseAccount)}
                    </button>
                    {showTwoButtons && (
                        <button className="mw-100 secondary" onClick={handleCompleteKycWithoutLinking}>
                            {formatMessage(messages.completeKycWithoutLinking)}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default Benefits;
